/**
 * こちらのファイルがビルドされて、common\js\build.jsに吐き出されます。
 * 各モジュールは、こちらのファイルから読み込んでください。
 *
 * 例) スムーススクロールモジュール読み込み、実行
 * import { setSmoothScroll } from '../common/setSmoothScroll';
 * setSmoothScroll();
 */

import { setSmoothScroll } from './common/setSmoothScroll';
import { setMatchHeight } from './common/setMatchHeight';
import { setCssVar } from './common/setCssVar';
import { setRakuten } from './common/setRakuten';
import { isRakuten } from './common/isRakuten';
import { header } from './modules/header';
import { lang } from './modules/lang';
import { bn } from './modules/bn';
import { tfvsl } from './modules/tfvsl';
import { grsl } from './modules/grsl';
import { sl1 } from './modules/sl1';
import { sl2 } from './modules/sl2';
import { grpopup } from './modules/grpopup';
import { sa } from './modules/sa';
import { menu } from './modules/menu';
import { tn } from './modules/tn';
import { reservation } from './modules/reservation';
import { loadNews } from './modules/loadNews';
import { setMovie } from './modules/setMovie';
import { frm } from './modules/frm';
import { setForm } from './modules/setForm';

if (isRakuten()) {
  setRakuten();
} else {
  header();
  lang();
  reservation();
  loadNews();
  menu();
}
tfvsl();
sl1();
sl2();
grpopup();
sa();
bn();
tn();
setSmoothScroll();
setMatchHeight();
setCssVar();
setMovie();
frm();
setForm();
grsl();
